import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import agentsReducer from './agentsSlice';
import listenersReducer from './listenersSlice';
import tasksReducer from './tasksSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    agents: agentsReducer,
    listeners: listenersReducer,
    tasks: tasksReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
